import { ip_back } from "../config";

function authHeaders() {
  const token =
    (typeof window !== "undefined" && localStorage.getItem("token")) || "";
  return token
    ? { Authorization: token, "Content-Type": "application/json" }
    : { "Content-Type": "application/json" };
}

async function parseJson(resp) {
  try {
    return await resp.json();
  } catch {
    return {};
  }
}

function clipQuery(teId, videoUrl) {
  const params = new URLSearchParams();
  if (teId) params.set("te_id", String(teId));
  if (videoUrl) params.set("video_url", String(videoUrl));
  return params.toString();
}

/**
 * Load persisted stroke gesture analyses for a clip.
 * @returns {Promise<{status:string, result?:object, source_signature?:string}|null>}
 */
export async function fetchStrokeAnalysis(teId, { videoUrl = null } = {}) {
  if (!teId) return null;
  const qs = clipQuery(teId, videoUrl);
  const resp = await fetch(`${ip_back}api/mobileAPI/pose/stroke-analysis?${qs}`, {
    method: "GET",
    headers: authHeaders(),
  });
  const body = await parseJson(resp);
  if (!resp.ok || body?.status === false) {
    throw new Error(body?.message || `Stroke analysis load failed (${resp.status})`);
  }
  return body?.data || null;
}

/**
 * Upsert stroke gesture analyses for a clip.
 */
export async function saveStrokeAnalysis(
  teId,
  {
    videoUrl = null,
    poseJobId = null,
    sourceSignature = null,
    result,
  } = {}
) {
  if (!teId) throw new Error("te_id required");
  if (!result || typeof result !== "object") {
    throw new Error("result required");
  }
  const resp = await fetch(`${ip_back}api/mobileAPI/pose/stroke-analysis`, {
    method: "PUT",
    headers: authHeaders(),
    body: JSON.stringify({
      te_id: teId,
      video_url: videoUrl || undefined,
      pose_job_id: poseJobId || undefined,
      source_signature: sourceSignature || result.source_signature || undefined,
      result,
    }),
  });
  const body = await parseJson(resp);
  if (!resp.ok || body?.status === false) {
    throw new Error(body?.message || `Stroke analysis save failed (${resp.status})`);
  }
  return body?.data || null;
}
